import deleteFilesRequest from '@picsart/cloud-storage/api/deleteFiles';

import { ErrorMessages } from '@/consts/errors';
import { getCloudStorageHeaders, withCloudStorageErrorHandling } from './utils';

const deleteDriveFiles = async (fileUids: string[]) => {
  return withCloudStorageErrorHandling({
    operation: () =>
      deleteFilesRequest({ headers: getCloudStorageHeaders(), fileUids }),
    errorMessage: ErrorMessages.deleteFiles,
  });
};

export default deleteDriveFiles;
